import PropTypes from 'prop-types'
import Stamp from './Stamp'
import { statusMeta } from './statusTones'

/**
 * A status as a flat label, in the tone the shared status map gives it.
 * `<StatusStamp status="paid" />` prints "Paid" in status-ok green;
 * `children` replace the printed word ("Signed Oct 3") and keep the tone.
 * A `meta` from `statusMeta()` works the same way. `onCarbon` prints the
 * label in ink: the status inks only just pass on the Carbon tint.
 */
export default function StatusStamp({
  status,
  meta,
  size = 'sm',
  onCarbon = false,
  className = '',
  children,
  ...rest
}) {
  if (!status && !meta) return null
  const resolved = meta
    ? statusMeta(meta.status || meta.label, children ?? meta.label)
    : statusMeta(status, children)
  return (
    <Stamp
      tone={resolved.faint ? 'faint' : onCarbon ? 'ink' : resolved.tone}
      size={size}
      className={`align-middle ${className}`}
      {...rest}
    >
      {resolved.label}
    </Stamp>
  )
}

StatusStamp.propTypes = {
  status: PropTypes.string,
  meta: PropTypes.shape({
    status: PropTypes.string,
    label: PropTypes.node,
  }),
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  onCarbon: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node,
}
